// extracted by mini-css-extract-plugin
export default {"container":"HachToanSummary_container__VpIYG","caption":"HachToanSummary_caption__vaL3P"};